
import { message } from 'antd';
import { ReactNode } from 'react';

message.config({
    top: 146,
    duration: 2,
    maxCount: 4
});

// 弹出提示窗口
export const toast = {
    destory: (key?: string) => {
        message.destroy(key)
    },

    success: (content: string | ReactNode, duration?: number) => {
        message.success({
            content,
            className: 'toast-success',
            duration: duration ? 5 : 2,
        });
    },
    loading: (content: string | ReactNode, duration?: number, key?: string) => {
        message.loading({
            content,
            key,
            className: 'toast-loading',
            duration: duration ?? 5,
        });
    },
    error: (content: string | ReactNode, duration?: number) => {
        message.error({
            content,
            className: 'toast-error',
            duration: duration ? 5 : 2,
        });
    },

    info: (content: string | ReactNode, duration?: number) => {
        message.info({
            content,
            className: 'toast-info',
            duration: duration ? 5 : 2,
        });
    },

    warning: (content: string | ReactNode, duration?: number, key?: string) => {
        message.warning({
            content,
            key,
            className: 'toast-warning',
            duration: duration ? 5 : 2,
        });
    },

}
